
'use strict';

var $ = require('jquery'),
  SecondaryNav = require('./SecondaryNav');

$('.SecondaryNav').each(function() {
  new SecondaryNav({
    el: this
  });
});

if ($('.js-SideNav').length) {
  var SideNav = require('./sideNav');
  new SideNav({
    el: '.js-SideNav'
  });
}



// WEBPACK FOOTER //
// ./assets/js/navigation/navigation.js